const styles = {
       controlButtons: {
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              backgroundColor: 'white',
              marginBottom: '16px',
              borderRadius: '4px',
              padding: '8px',
       },
       buttonSection: {
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              justifyContent: 'center',
       },
       iconButton: {
              minWidth: 'auto',
              px: 1,
              py: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
       },
       spinner: {
              color: '#4caf50', // Green color
              width: '20px !important',
              height: '20px !important',
       },
       saveIcon: {
              color: '#ed6c02', // Orange color
       },
       cancelIcon: {
              color: '#f44336', // Red color
       },
       submitIcon: {
              color: '#4caf50', // Green color
       },
};

export default styles; 